import yup from "./yup";

export const userSchema = yup.object().shape({
    dynamicsId:
        yup.string().label('DynamicsId')
            .required(),
    fullName:
        yup.string().label('Nombre')
            .required(),
    userName:
        yup.string().label('Usuario')
            .required(),
    email:
        yup.string().label('Email').email()
            .required(),
    address:
        yup.string()
            .label('Dirección'),
    city:
        yup.string()
            .label('Ciudad'),
    state:
        yup.string()
            .label('Provincia'),
    country:
        yup.string()
            .label('Pais'),
    phoneNumber:
        yup.string()
            .label('Teléfono'),
    disabledPassword:
        yup.boolean()
            .label("Ingresar sin contraseña"),
    password:
        yup.string().label('Contraseña')
            .when("disabledPassword", {
                is: false,
                then: yup.string().required(),
                otherwise: yup.string().nullable(),
            }),
    passwordConfirm:
        yup.string().label('Contraseña Confirmar')
            .when("disabledPassword", {
                is: false,
                then: yup.string().oneOf([yup.ref('password'), null], "Las Contraseñas no coinciden").required(),
                otherwise: yup.string().nullable(),
            })
});